import searchResultsHeader from './search/search-results-header'
import emptySearchResults from './search/empty-search-results/empty-search-results'
import storiesGrid from './search/stories-grid'

const productListingBase = {
    ProductListing: {
        baseStyle: () => ({
            wrapper: {
                pos: 'relative',
                alignItems: 'flex-start',
                pt: {base: 'space.padding.vertical.gridTop.base', sm: 'space.padding.vertical.gridTop.sm', xl: 'space.padding.vertical.gridTop.xl'},
                // pb: 'space.padding.vertical.gridBottom',
                gap: 0,
            },
            listWrapper: {
                w: '100%',
                rowGap: 'space.padding.vertical.3xl',
            },
        }),
        variants: {
            grid3: {
                wrapper: {
                    px: {base: 'space.padding.horizontal.grid3.base', sm: 'space.padding.horizontal.grid3.sm', xl: 'space.padding.horizontal.grid3.xl'},
                },
                listWrapper: {
                    gridTemplateColumns: {base: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)'},
                    columnGap: {base: 'space.gap.horizontal.grid3.base', md: 'space.gap.horizontal.grid3.md'},
                },
            },
            grid2: {
                wrapper: {
                    px: {base: 'space.padding.horizontal.grid2.base', sm: 'space.padding.horizontal.grid2.sm', xl: 'space.padding.horizontal.grid2.xl'},
                },
                listWrapper: {
                    gridTemplateColumns: {base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)'},
                    columnGap: {base: 'space.gap.horizontal.grid2.base', sm: 'space.gap.horizontal.grid2.sm'},
                },
            },
            wishlist: {
                wrapper: {
                    px: {base: 'space.padding.horizontal.grid3.base', sm: 'space.padding.horizontal.grid3.sm', xl: 'space.padding.horizontal.grid3.xl'},
                },
                listWrapper: {
                    gridTemplateColumns: {base: 'repeat(2, 1fr)', md: 'repeat(2, 1fr)', xl: 'repeat(3, 1fr)'}, // TODO: Adjust the 2, 1fr on base; should be 1, 1fr
                    columnGap: 'spacing.8',
                },
            },
        },
    },
}

const productListing = {
    ...productListingBase,
    ...searchResultsHeader,
    ...storiesGrid,
    ...emptySearchResults,
}

export default productListing
